import dayjs from "../../../utils/date-utils";

const authAuditProvideStartAt = dayjs("2021-04-01", "YYYY-MM-DD");

export type AuthAuditLogView = {
  userId: string;
  userName: string;
  description: string;
  ipAddress: string;
  occurAt: string;
};

export function isAuthAuditLogOutsideTimestamp(day: Date): boolean {
  return (
    authAuditProvideStartAt.isAfter(day) ||
    !dayjs(day).isBetween(dayjs().add(-90, "day"), dayjs(), "day", "[]")
  );
}

export function getOldestDateViewable() {
  return dayjs().add(-90, "day").toDate();
}
